import {
  WithStyles,
  Theme,
  createStyles,
  withStyles,
  Typography,
  Box
} from "@material-ui/core";
import * as React from "react";

const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: "100%",
      padding: 3
    },
    button: {
      margin: theme.spacing(1),
      width: "20%",
      height: 48
    },
    paper: {
      padding: theme.spacing(1) * 2,
      textAlign: "center",
      height: "100%",
      color: theme.palette.text.secondary
    },
    control: {
      padding: theme.spacing(1) * 2
    }
  });
interface Props extends WithStyles<typeof styles> {
  children: any;
  value: any;
  index: any;
}
class TabPanel extends React.Component<Props> {
  render() {
    const { children, value, index } = this.props;
    return (
      <Typography
        component="div"
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
      >
        {value === index && (
          <Box style={{ height: window.innerHeight }} p={3}>
            {children}
          </Box>
        )}
      </Typography>
    );
  }
}
export default withStyles(styles)(TabPanel);
